export const inventoryLink = (companyName: string, id: string) => {
  const [productId, productVariantId] = id.split('-');
  const shopName = companyName.replace('.myshopify.com', '');

  return `https://admin.shopify.com/store/${shopName}/products/${productId}/variants/${productVariantId}`;
};

export const productLink = (companyName: string, id: string) => {
  let [, productVariantId, ...rest] = id.split('-');

  productVariantId = productVariantId.split(':')[1];
  const productName = rest.join('-').split(':')[1];

  return `https://${companyName}.myshopify.com/products/${productName}?variant=${productVariantId}`;
};
